// @ts-nocheck
/* eslint-disable */
export const defenseIcon = {
  data: `<svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.38062 2.67318C5.4351 2.67318 3.04728 5.06099 3.04728 8.00651C3.04728 10.952 5.4351 13.3398 8.38062 13.3398" stroke="currentColor" stroke-linecap="round"/><path d="M13.7139 8.00781H7.04727M7.04727 8.00781L9.04727 10.0078M7.04727 8.00781L9.04727 6.00781" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'defense' as const,
};
